import React from 'react';

import classNames from 'classnames';

export default function Tab({ isActive, label, onClick, displayLabel }) {
  return (
    <li className="mr-6 last:mr-0 first:pl-4 sm:first:pl-6 lg:first:pl-8 last:pr-4 sm:last:pr-6 lg:last:pr-8">
      <button
        type="button"
        className={classNames({
          'block pb-3 text-indigo-500 whitespace-nowrap border-b-2 border-indigo-500':
            isActive,
          'block pb-3 text-slate-500 dark:text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 whitespace-nowrap':
            !isActive,
        })}
        onClick={onClick}
      >
        {displayLabel || label}
      </button>
    </li>
  );
}
